import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Pill } from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import { QuickLinksContext } from './QuickLinksContext';

const LinkPill = ({ link, index }) => {
  const { id } = link;
  const { pillVariant } = useContext(QuickLinksContext);
  const { ref, clickID } = useImpression({
    data: {
      component: 'LinksContent',
      name: 'LinksContent',
      id,
      position: index + 1,
      type: 'content',
    }
  });

  return (
    <div
      className="first:sui-snap-start last:sui-snap-end"
      key={id}
      data-contentful-entry-id={id}
      data-contentful-field-id="label"
    >
      <Pill
        key={`${id}-pill`}
        ref={ref}
        clickid={clickID}
        component="a"
        label={link?.label}
        href={link?.href}
        target={link?.openInNewTab ? '_blank' : undefined}
        rel={link?.openInNewTab ? 'noopener noreferrer' : undefined}
        onClick={link?.onClick}
        variant={pillVariant}
        clickable
        draggable={false}
      />
    </div>
  );
};

LinkPill.propTypes = {
  link: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool,
    onClick: PropTypes.func,
  }).isRequired,
  index: PropTypes.number.isRequired
};

export default LinkPill;
